import { connect } from "react-redux";

import {
  selectIsDrawingMode,
  selectIsFreeDrawing,
  selectShapeType,
  selectPrimaryColorString,
  setSelectionColorString,
  setShapeType,
  setDrawingMode,
  selectStrokeWidth,
  setSelectionStrokeWidth
} from "~/store/ducks/application/fabric";

import {
  addAnnotation,
  updateAnnotation,
  addToSelection,
  removeFromSelection,
  selectToDelete,
  clearSelectionToDelete,
  clearSelection,
  deleteSelected,
  deleteAllAnnotations,
  selectAnnotationsByPageAndBook
} from "~/store/ducks/user/annotations";

import LinenCloth from "./LinenCloth";

function mapStateToProps(state, ownProps) {
  // const selectAnnotations = selectAnnotationsByPageSorted(ownProps.page - 1);
  const selectAnnotations = selectAnnotationsByPageAndBook(ownProps.page, ownProps.bookId);

  return _state => ({
    isDrawingMode: selectIsDrawingMode(_state),
    isFreeDrawing: selectIsFreeDrawing(_state),
    shapeType: selectShapeType(_state),
    primaryColor: selectPrimaryColorString(_state),
    annotations: selectAnnotations(_state),
    toDelete: selectToDelete(_state),
    strokeWidth: selectStrokeWidth(_state)
  });
}

const mapDispatchToProps = {
  addAnnotation,
  updateAnnotation,
  setShapeType,
  addToSelection,
  removeFromSelection,
  clearSelectionToDelete,
  clearSelection,
  setDrawingMode,
  deleteSelected,
  deleteAllAnnotations,
  setSelectionColorString,
  setSelectionStrokeWidth
};

export default connect(mapStateToProps, mapDispatchToProps)(LinenCloth);
